import React from "react";
import { RouteComponentProps } from "../../models/RouteComponent";
import {TabPanel, TabView} from "primereact/tabview";
import BillingAdminUsageTable from "./billing-AdminUsageTable";


export default function BillingView(props: RouteComponentProps) {

  return (
    <React.Fragment>

      <TabView>
        <TabPanel header="Usage">
          <BillingAdminUsageTable {...props} />
        </TabPanel>
      </TabView>

    </React.Fragment>
  );
}
